import Script from 'next/script';
import React from 'react';

const Video = ({
  name = 'Title for video',
  image = `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/features/sq/hero.svg`,
  wistiaId = false,
  className = `max-w-3xl`,
}) => {
  const handlePlay = () => {
    if (typeof mixpanel !== 'undefined') {
      mixpanel?.track?.('Play Video', { video: name });
    }

    document.getElementById('playVideo').click();
  };

  return (
    <div>
      <figure
        className={`relative mx-auto z-10 overflow-hidden ${className}`}
        onClick={handlePlay}
      >
        <div className="relative">
          {wistiaId && (
            <button
              className="z-20 absolute bg-primary focus:outline-none h-24 w-24 text-2xl rounded-full flex items-center transition-transform duration-300 ease-in-out transform -translate-x-1/2 -translate-y-1/2 scale-100 hover:scale-110 justify-center text-white shadow-lg"
              style={{
                top: '50%',
                left: '50%',
                '--transform-translate-z': '0',
                willChange: 'transform',
              }}
            >
              <svg
                stroke="currentColor"
                fill="white"
                strokeWidth={2}
                viewBox="0 0 24 24"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="ml-1"
                style={{ marginTop: '2px' }}
                height="1.5em"
                width="1.5em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>
            </button>
          )}

          <img
            src={image}
            style={{ minHeight: `200px` }}
            className="shadow-header fade rounded-lg"
          />
        </div>
        {wistiaId && (
          <>
            <Script
              src="//fast.wistia.com/assets/external/E-v1.js"
              strategy="afterInteractive"
            />
            <div
              className={`wistia_embed wistia_async_${wistiaId} popover=true popoverContent=html`}
              style={{
                display: 'inline-block',
                whiteSpace: 'nowrap',
                position: 'relative',
              }}
            >
              <a id="playVideo" href="#"></a>
            </div>
          </>
        )}
      </figure>
    </div>
  );
};

export default Video;
